<template>
  <v-card elevation="2" style="height:calc(100vh - 100px)">
    <v-card-text>Розница</v-card-text>
  </v-card>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
</style>